import React from 'react';
import ContentLayout from '../components/ContentLayout';
import TermsContent from '../components/TermsContent';

const TermsPage = () => (
  <ContentLayout
    testid="page-terms"
    eyebrow="Legal"
    titleTop="Terms &"
    titleItalic="Conditions"
    intro="Please read these terms carefully before using Osho Universal’s website and services. By accessing our site, booking programs, or making a contribution, you agree to the following terms. All information and techniques we share are offered for your independent evaluation and are used entirely at your own risk."
  >
    <TermsContent />
  </ContentLayout>
);

export default TermsPage;
